namespace TabAurous.Production {
    export namespace WIPMovementSelectSubBagsService {
        export const baseUrl = 'Production/WIPMovementSelectSubBags';

        export declare function List(request: CommonMFGRequest, onSuccess?: (response: Serenity.ListResponse<WIPMovementRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/WIPMovementSelectSubBags/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>WIPMovementSelectSubBagsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
